export default __webpack_public_path__ + "static/media/import-csv-example-fi.ed575a25.csv";